// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var WebGraphql_Shifts = require("../graphql/WebGraphql_Shifts.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Types_State = require("./WebStore_Types_State.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var WebStore_ThunkHelpers = require("./WebStore_ThunkHelpers.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");
var WebGraphql_ManageUsers = require("../graphql/WebGraphql_ManageUsers.bs.js");
var WebTypes_PostAShift_Step = require("../types/WebTypes_PostAShift_Step.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_Accessory = require("../../../shared/src/types/CommonTypes_Shift_Accessory.bs.js");
var CommonTypes_Business_Manager = require("../../../shared/src/types/business/CommonTypes_Business_Manager.bs.js");
var CommonTypes_Business_RequestableWorker = require("../../../shared/src/types/business/CommonTypes_Business_RequestableWorker.bs.js");

function getter(param) {
  return param.postAShift;
}

function setter(postAShift, state) {
  return {
          cities: state.cities,
          currentUser: state.currentUser,
          dashboard: state.dashboard,
          editingShift: state.editingShift,
          layout: state.layout,
          postAShift: postAShift,
          savedBusinessAdmins: state.savedBusinessAdmins,
          savedBusinessManagers: state.savedBusinessManagers,
          savedLocations: state.savedLocations,
          token: state.token,
          timing: state.timing,
          view: state.view
        };
}

var LensedThunkHelpers = Curry._1(WebStore_ThunkHelpers.Lens, {
      getter: getter,
      setter: setter,
      actionWrapper: WebStore_Types_Action.postAShift
    });

function getSavedManagers(param) {
  return Relude_Option.getOrElse(CommonTypes_Business_Manager.$$Set.empty, Relude_AsyncResult.getCompleteOk(param.postAShift.savedManagers));
}

function getSelectedManager(param) {
  var onsiteManagerPhoneNumber = param.onsiteManager.phoneNumber;
  var partial_arg = Curry._1(Relude_Array.find, (function (param) {
          return CommonTypes_LongPhoneNumber.eq(param.phoneNumber, onsiteManagerPhoneNumber);
        }));
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(getSavedManagers, Relude_Set.toArray, param);
                }), partial_arg, param);
  };
}

function createCopiedShiftBasicInfo(param) {
  return {
          hourlyRate: Relude_Int.toFloat(param.hourlyRateCents) / 100.0,
          numberOfWorkers: param.originalNumberOfWorkers,
          requestedWorkers: CommonTypes_Business_RequestableWorker.$$Set.empty,
          shiftType: param.shiftType,
          tipsPayoutType: param.tipsPayoutType
        };
}

function createCopiedShiftDetails(shift) {
  var partial_arg = getSelectedManager(shift);
  return function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (param) {
                  return {
                          accessories: CommonTypes_Shift_Accessory.toShiftTypeAccessorySet(shift.accessories),
                          attire: shift.attire,
                          copiedFrom: Caml_option.some(shift.id),
                          description: shift.description,
                          dressCode: shift.dressCode,
                          onsiteManagerFirstName: Relude_Option.fold("", (function (param) {
                                  return Curry._1(CommonTypes_User_Name.FirstName.toString, param.name.firstName);
                                }), param),
                          onsiteManagerLastName: Relude_Option.fold("", (function (param) {
                                  return Curry._1(CommonTypes_User_Name.LastName.toString, param.name.lastName);
                                }), param),
                          onsiteManagerPhoneNumber: Relude_Option.getOrElse(CommonTypes_LongPhoneNumber.$$default, Relude_Option.map((function (param) {
                                      return param.phoneNumber;
                                    }), param)),
                          selectedManager: param
                        };
                }), param);
  };
}

function createCopiedShiftLocation(geocode, param) {
  var existingLocation = param.location;
  return {
          address: existingLocation.address,
          existingLocation: Relude_Option.pure(existingLocation),
          geocode: geocode,
          locationName: existingLocation.name,
          parkingCost: param.parkingCost,
          parkingInstructions: param.parkingInstructions
        };
}

function reducer(param) {
  var step = param[0];
  if (typeof step === "number") {
    switch (step) {
      case /* FetchRequestableWorkers */0 :
          return {
                  TAG: /* SideEffects */1,
                  _0: Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.PostAShift.updateRequestableWorkers, Curry._1(WebGraphql_Shifts.GetRequestedWorkers.queryAsyncResult, undefined))
                };
      case /* FetchSavedManagers */1 :
          return {
                  TAG: /* SideEffects */1,
                  _0: Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.PostAShift.updateSavedManagers, Curry._1(WebGraphql_ManageUsers.GetOnsiteManagers.queryAsyncResult, undefined))
                };
      case /* FetchShiftTypes */2 :
          return {
                  TAG: /* SideEffects */1,
                  _0: Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.PostAShift.updateShiftTypes, Curry._1(WebGraphql_Shifts.GetShiftTypes.queryAsyncResult, undefined))
                };
      case /* Reset */3 :
          var state = param[1];
          return Store.update({
                      cities: state.cities,
                      currentUser: state.currentUser,
                      dashboard: state.dashboard,
                      editingShift: state.editingShift,
                      layout: state.layout,
                      postAShift: WebStore_Types_State.PostAShift.initialState,
                      savedBusinessAdmins: state.savedBusinessAdmins,
                      savedBusinessManagers: state.savedBusinessManagers,
                      savedLocations: state.savedLocations,
                      token: state.token,
                      timing: state.timing,
                      view: state.view
                    });
      
    }
  } else {
    switch (step.TAG | 0) {
      case /* AddAvailableShiftStep */0 :
          var state$1 = param[1];
          var postAShift = state$1.postAShift;
          return Store.update({
                      cities: state$1.cities,
                      currentUser: state$1.currentUser,
                      dashboard: state$1.dashboard,
                      editingShift: state$1.editingShift,
                      layout: state$1.layout,
                      postAShift: {
                        availableShiftSteps: Curry._2(WebTypes_PostAShift_Step.$$Set.add, step._0, postAShift.availableShiftSteps),
                        currentShiftStep: postAShift.currentShiftStep,
                        newShift: postAShift.newShift,
                        requestableWorkers: postAShift.requestableWorkers,
                        savedManagers: postAShift.savedManagers,
                        shiftTypes: postAShift.shiftTypes
                      },
                      savedBusinessAdmins: state$1.savedBusinessAdmins,
                      savedBusinessManagers: state$1.savedBusinessManagers,
                      savedLocations: state$1.savedLocations,
                      token: state$1.token,
                      timing: state$1.timing,
                      view: state$1.view
                    });
      case /* CopyShiftById */1 :
          return {
                  TAG: /* SideEffects */1,
                  _0: Curry._3(LensedThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.PostAShift.fetchGeocodeForCopiedShift, Curry._1(WebGraphql_Shifts.GetShiftById.queryAsyncResult, step._0))
                };
      case /* FetchGeocodeForCopiedShift */2 :
          return Relude_Option.fold(Store.noUpdate, (function (shift) {
                        return {
                                TAG: /* SideEffects */1,
                                _0: Curry._3(LensedThunkHelpers.loadAsyncData, undefined, (function (param) {
                                        return WebStore_Types_Action.PostAShift.updateCopiedShift(shift, param);
                                      }), Curry._1(WebGraphql_Shifts.GeocodeAddress.queryAsyncResult, shift.location.address))
                              };
                      }), Relude_AsyncResult.getCompleteOk(step._0));
      case /* SetToMinimumShiftStep */3 :
          var state$2 = param[1];
          var postAShift$1 = state$2.postAShift;
          var desiredShiftStep = step._0;
          return {
                  TAG: /* UpdateWithSideEffects */2,
                  _0: {
                    cities: state$2.cities,
                    currentUser: state$2.currentUser,
                    dashboard: state$2.dashboard,
                    editingShift: state$2.editingShift,
                    layout: state$2.layout,
                    postAShift: {
                      availableShiftSteps: postAShift$1.availableShiftSteps,
                      currentShiftStep: desiredShiftStep,
                      newShift: postAShift$1.newShift,
                      requestableWorkers: postAShift$1.requestableWorkers,
                      savedManagers: postAShift$1.savedManagers,
                      shiftTypes: postAShift$1.shiftTypes
                    },
                    savedBusinessAdmins: state$2.savedBusinessAdmins,
                    savedBusinessManagers: state$2.savedBusinessManagers,
                    savedLocations: state$2.savedLocations,
                    token: state$2.token,
                    timing: state$2.timing,
                    view: state$2.view
                  },
                  _1: (function (_state, dispatch) {
                      return Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.addAvailableShiftStep(desiredShiftStep)));
                    })
                };
      case /* UpdateCopiedShift */4 :
          var state$3 = param[1];
          var postAShift$2 = state$3.postAShift;
          var copiedShift = step._0;
          var timezone = copiedShift.timezone;
          var startDatetime = copiedShift.startDatetime;
          var parkingCost = copiedShift.parkingCost;
          var endDatetime = copiedShift.endDatetime;
          return Relude_Option.fold(Store.noUpdate, (function (param) {
                        return Store.update({
                                    cities: state$3.cities,
                                    currentUser: state$3.currentUser,
                                    dashboard: state$3.dashboard,
                                    editingShift: state$3.editingShift,
                                    layout: state$3.layout,
                                    postAShift: {
                                      availableShiftSteps: Curry._1(WebTypes_PostAShift_Step.$$Set.fromArray, [
                                            /* Location */0,
                                            /* DateTime */1
                                          ]),
                                      currentShiftStep: typeof parkingCost === "number" && parkingCost < 3 ? /* DateTime */1 : /* Location */0,
                                      newShift: {
                                        basicInfo: Relude_Option.pure(createCopiedShiftBasicInfo(copiedShift)),
                                        dates: {
                                          dates: [],
                                          startTime: {
                                            hours: Caml_format.caml_float_of_string(DateUtils.formatDate(/* Custom */{
                                                        _0: "HH"
                                                      }, /* Zone */{
                                                        _0: timezone
                                                      })(startDatetime)),
                                            minutes: Relude_Int.toFloat(DateUtils.getMinutesFromLuxon(DateUtils.getLuxonDate(startDatetime)))
                                          },
                                          endTime: {
                                            hours: Caml_format.caml_float_of_string(DateUtils.formatDate(/* Custom */{
                                                        _0: "HH"
                                                      }, /* Zone */{
                                                        _0: timezone
                                                      })(endDatetime)),
                                            minutes: Relude_Int.toFloat(DateUtils.getMinutesFromLuxon(DateUtils.getLuxonDate(endDatetime)))
                                          },
                                          timezone: timezone
                                        },
                                        details: Relude_Option.pure(createCopiedShiftDetails(copiedShift)(state$3)),
                                        location: Relude_Option.pure(createCopiedShiftLocation(param.geocode, copiedShift))
                                      },
                                      requestableWorkers: postAShift$2.requestableWorkers,
                                      savedManagers: postAShift$2.savedManagers,
                                      shiftTypes: postAShift$2.shiftTypes
                                    },
                                    savedBusinessAdmins: state$3.savedBusinessAdmins,
                                    savedBusinessManagers: state$3.savedBusinessManagers,
                                    savedLocations: state$3.savedLocations,
                                    token: state$3.token,
                                    timing: state$3.timing,
                                    view: state$3.view
                                  });
                      }), Relude_AsyncResult.getCompleteOk(step._1));
      case /* UpdateNewShift */5 :
          var state$4 = param[1];
          var postAShift$3 = state$4.postAShift;
          return Store.update({
                      cities: state$4.cities,
                      currentUser: state$4.currentUser,
                      dashboard: state$4.dashboard,
                      editingShift: state$4.editingShift,
                      layout: state$4.layout,
                      postAShift: {
                        availableShiftSteps: postAShift$3.availableShiftSteps,
                        currentShiftStep: postAShift$3.currentShiftStep,
                        newShift: step._0,
                        requestableWorkers: postAShift$3.requestableWorkers,
                        savedManagers: postAShift$3.savedManagers,
                        shiftTypes: postAShift$3.shiftTypes
                      },
                      savedBusinessAdmins: state$4.savedBusinessAdmins,
                      savedBusinessManagers: state$4.savedBusinessManagers,
                      savedLocations: state$4.savedLocations,
                      token: state$4.token,
                      timing: state$4.timing,
                      view: state$4.view
                    });
      case /* UpdateRequestableWorkers */6 :
          return Curry._4(LensedThunkHelpers.updateAsyncResult, (function (param) {
                        return param.requestableWorkers;
                      }), (function (state, requestableWorkers) {
                        return {
                                availableShiftSteps: state.availableShiftSteps,
                                currentShiftStep: state.currentShiftStep,
                                newShift: state.newShift,
                                requestableWorkers: requestableWorkers,
                                savedManagers: state.savedManagers,
                                shiftTypes: state.shiftTypes
                              };
                      }), param[1], step._0);
      case /* UpdateSavedManagers */7 :
          return Curry._4(LensedThunkHelpers.updateAsyncResult, (function (param) {
                        return param.savedManagers;
                      }), (function (state, savedManagers) {
                        return {
                                availableShiftSteps: state.availableShiftSteps,
                                currentShiftStep: state.currentShiftStep,
                                newShift: state.newShift,
                                requestableWorkers: state.requestableWorkers,
                                savedManagers: savedManagers,
                                shiftTypes: state.shiftTypes
                              };
                      }), param[1], step._0);
      case /* UpdateShiftTypes */8 :
          return Curry._4(LensedThunkHelpers.updateAsyncResult, (function (param) {
                        return param.shiftTypes;
                      }), (function (state, shiftTypes) {
                        return {
                                availableShiftSteps: state.availableShiftSteps,
                                currentShiftStep: state.currentShiftStep,
                                newShift: state.newShift,
                                requestableWorkers: state.requestableWorkers,
                                savedManagers: state.savedManagers,
                                shiftTypes: shiftTypes
                              };
                      }), param[1], step._0);
      
    }
  }
}

function reducer$1(param, param$1) {
  return Relude_Globals.flip((function (param, param$1) {
                return Relude_Function.curry2(reducer, param, param$1);
              }), param, param$1);
}

var Shift;

var User;

exports.Shift = Shift;
exports.User = User;
exports.LensedThunkHelpers = LensedThunkHelpers;
exports.getSavedManagers = getSavedManagers;
exports.getSelectedManager = getSelectedManager;
exports.createCopiedShiftBasicInfo = createCopiedShiftBasicInfo;
exports.createCopiedShiftDetails = createCopiedShiftDetails;
exports.createCopiedShiftLocation = createCopiedShiftLocation;
exports.reducer = reducer$1;
/* LensedThunkHelpers Not a pure module */
